import { createActions } from 'redux-actions';
import { request } from '../../services';

const {
  travelingWorkDateIndexRequest,
  travelingWorkDateIndexSuccess,
  travelingWorkDateIndexFailure,
} = createActions('TRAVELING_WORK_DATE_INDEX_REQUEST', 'TRAVELING_WORK_DATE_INDEX_SUCCESS', 'TRAVELING_WORK_DATE_INDEX_FAILURE');

export function requestTravelingWorkDatesList(parentID, parentKind) {
  return (dispatch) => {
    dispatch(travelingWorkDateIndexRequest());

    return request(`${parentKind}/${parentID}/traveling_work_dates`)
      .then(({ json }) => dispatch(travelingWorkDateIndexSuccess(json)))
      .catch(error => dispatch(travelingWorkDateIndexFailure(error)));
  };
}

const {
  travelingWorkDateCreateRequest,
  travelingWorkDateCreateSuccess,
  travelingWorkDateCreateFailure,
} = createActions('TRAVELING_WORK_DATE_CREATE_REQUEST', 'TRAVELING_WORK_DATE_CREATE_SUCCESS', 'TRAVELING_WORK_DATE_CREATE_FAILURE');

export function createTravelingWorkDate(parentID, parentKind, travelingWorkDate) {
  return (dispatch) => {
    dispatch(travelingWorkDateCreateRequest());
    return request(`${parentKind}/${parentID}/traveling_work_dates`, { method: 'POST', body: { traveling_work_date: travelingWorkDate } })
      .then(({ json }) => dispatch(travelingWorkDateCreateSuccess(json)))
      .catch(({ errors }) =>
        dispatch(travelingWorkDateCreateFailure({ travelingWorkDate, errors })));
  };
}

const {
  travelingWorkDateUpdateRequest,
  travelingWorkDateUpdateSuccess,
  travelingWorkDateUpdateFailure,
} = createActions('TRAVELING_WORK_DATE_UPDATE_SUCCESS', 'TRAVELING_WORK_DATE_UPDATE_REQUEST', 'TRAVELING_WORK_DATE_UPDATE_FAILURE');

export function updateTravelingWorkDate(travelingWorkDateID, travelingWorkDate) {
  return (dispatch) => {
    dispatch(travelingWorkDateUpdateRequest());

    return request(`traveling_work_dates/${travelingWorkDateID}`, { method: 'PATCH', body: { traveling_work_date: travelingWorkDate } })
      .then(({ json }) => dispatch(travelingWorkDateUpdateSuccess(json)))
      .catch(({ errors }) =>
        dispatch(travelingWorkDateUpdateFailure({ travelingWorkDate, errors })));
  };
}

const {
  travelingWorkDateDeleteRequest,
  travelingWorkDateDeleteSuccess,
  travelingWorkDateDeleteFailure,
} = createActions('TRAVELING_WORK_DATE_DELETE_SUCCESS', 'TRAVELING_WORK_DATE_DELETE_REQUEST', 'TRAVELING_WORK_DATE_DELETE_FAILURE');

export function deleteTravelingWorkDate(travelingWorkDateID) {
  return (dispatch) => {
    dispatch(travelingWorkDateDeleteRequest());

    return request(`traveling_work_dates/${travelingWorkDateID}`, { method: 'DELETE' })
      .then(() => dispatch(travelingWorkDateDeleteSuccess({ travelingWorkDateID })))
      .catch(error => dispatch(travelingWorkDateDeleteFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/traveling_work_dates.js